// @core/api/endpoints/workflow/start_debug_session.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DebugSessionResponse,
  StartDebugSessionRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Start debug session
 * Starts an interactive debug session for a pipeline. The pipeline runs in DRY_RUN mode with breakpoint support.
 */
export async function StartDebugSession(
  pipeline_id: string,
  data: StartDebugSessionRequest,
  options?: RequestOptions
): Promise<DebugSessionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/debug`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<DebugSessionResponse>(requestPath, data, requestOptions);
}
